const SchemaMarkup = ({ schema }) => {
  return (
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema).replace(/</g, '\\u003c').replace(/>/g, '\\u003e') }} />
  );
};

export default SchemaMarkup;